export const appdata = {
    hp: [{
        "level": -1,
        "high": "9-10",
        "moderate": "8-7",
        "low": "6-5"
    },
    {
        "level": 0,
        "high": "20-17",
        "moderate": "16-14",
        "low": "13-11"
    },
    {
        "level": 1,
        "high": "26-24",
        "moderate": "21-19",
        "low": "16-14"
    },
    {
        "level": 2,
        "high": "40-36",
        "moderate": "32-28",
        "low": "25-21"
    },
    {
        "level": 3,
        "high": "59-53",
        "moderate": "48-42",
        "low": "37-31"
    },
    {
        "level": 4,
        "high": "78-72",
        "moderate": "63-57",
        "low": "48-42"
    },
    {
        "level": 5,
        "high": "97-91",
        "moderate": "78-72",
        "low": "59-53"
    },
    {
        "level": 6,
        "high": "123-115",
        "moderate": "99-91",
        "low": "75-67"
    },
    {
        "level": 7,
        "high": "148-140",
        "moderate": "119-111",
        "low": "90-82"
    },
    {
        "level": 8,
        "high": "173-165",
        "moderate": "139-131",
        "low": "105-97"
    },
    {
        "level": 9,
        "high": "198-190",
        "moderate": "159-151",
        "low": "120-112"
    },
    {
        "level": 10,
        "high": "223-215",
        "moderate": "179-171",
        "low": "135-127"
    },
    {
        "level": 11,
        "high": "248-240",
        "moderate": "199-191",
        "low": "150-142"
    },
    {
        "level": 12,
        "high": "273-265",
        "moderate": "219-211",
        "low": "165-157"
    },
    {
        "level": 13,
        "high": "298-290",
        "moderate": "239-231",
        "low": "180-172"
    },
    {
        "level": 14,
        "high": "323-315",
        "moderate": "259-251",
        "low": "195-187"
    },
    {
        "level": 15,
        "high": "348-340",
        "moderate": "279-271",
        "low": "210-202"
    },
    {
        "level": 16,
        "high": "373-365",
        "moderate": "299-291",
        "low": "225-217"
    },
    {
        "level": 17,
        "high": "398-390",
        "moderate": "319-311",
        "low": "240-232"
    },
    {
        "level": 18,
        "high": "423-415",
        "moderate": "339-331",
        "low": "255-247"
    },
    {
        "level": 19,
        "high": "448-440",
        "moderate": "359-351",
        "low": "270-262"
    },
    {
        "level": 20,
        "high": "473-465",
        "moderate": "379-371",
        "low": "285-277"
    },
    {
        "level": 21,
        "high": "505-495",
        "moderate": "405-395",
        "low": "305-295"
    },
    {
        "level": 22,
        "high": "544-532",
        "moderate": "436-424",
        "low": "329-317"
    },
    {
        "level": 23,
        "high": "581-569",
        "moderate": "466-454",
        "low": "351-339"
    },
    {
        "level": 24,
        "high": "633-617",
        "moderate": "508-492",
        "low": "383-367"
    }
    ],
    ability: [{
        "level": -1,
        "extreme": 3,
        "high": 3,
        "moderate": 2,
        "low": 0,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 0,
        "extreme": 3,
        "high": 3,
        "moderate": 2,
        "low": 0,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 1,
        "extreme": 5,
        "high": 4,
        "moderate": 3,
        "low": 1,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 2,
        "extreme": 5,
        "high": 4,
        "moderate": 3,
        "low": 1,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 3,
        "extreme": 5,
        "high": 4,
        "moderate": 3,
        "low": 1,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 4,
        "extreme": 6,
        "high": 5,
        "moderate": 3,
        "low": 2,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 5,
        "extreme": 6,
        "high": 5,
        "moderate": 4,
        "low": 2,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 6,
        "extreme": 7,
        "high": 5,
        "moderate": 4,
        "low": 2,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 7,
        "extreme": 7,
        "high": 6,
        "moderate": 4,
        "low": 2,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 8,
        "extreme": 7,
        "high": 6,
        "moderate": 4,
        "low": 3,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 9,
        "extreme": 7,
        "high": 6,
        "moderate": 4,
        "low": 3,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 10,
        "extreme": 8,
        "high": 7,
        "moderate": 5,
        "low": 3,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 11,
        "extreme": 8,
        "high": 7,
        "moderate": 5,
        "low": 3,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 12,
        "extreme": 8,
        "high": 7,
        "moderate": 5,
        "low": 4,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 13,
        "extreme": 9,
        "high": 8,
        "moderate": 5,
        "low": 4,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 14,
        "extreme": 9,
        "high": 8,
        "moderate": 5,
        "low": 4,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 15,
        "extreme": 9,
        "high": 8,
        "moderate": 6,
        "low": 4,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 16,
        "extreme": 10,
        "high": 9,
        "moderate": 6,
        "low": 5,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 17,
        "extreme": 10,
        "high": 9,
        "moderate": 6,
        "low": 5,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 18,
        "extreme": 10,
        "high": 9,
        "moderate": 6,
        "low": 5,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 19,
        "extreme": 11,
        "high": 10,
        "moderate": 6,
        "low": 5,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 20,
        "extreme": 11,
        "high": 10,
        "moderate": 7,
        "low": 6,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 21,
        "extreme": 11,
        "high": 10,
        "moderate": 7,
        "low": 6,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 22,
        "extreme": 11,
        "high": 10,
        "moderate": 8,
        "low": 6,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 23,
        "extreme": 11,
        "high": 10,
        "moderate": 8,
        "low": 6,
        "terrible": -4,
        "abysmal": -5
    },
    {
        "level": 24,
        "extreme": 13,
        "high": 12,
        "moderate": 9,
        "low": 7,
        "terrible": -4,
        "abysmal": -5
    }
    ],
    save: [{
        "level": -1,
        "extreme": 9,
        "high": 8,
        "moderate": 5,
        "low": 2,
        "terrible": 0
    },
    {
        "level": 0,
        "extreme": 10,
        "high": 9,
        "moderate": 6,
        "low": 3,
        "terrible": 1
    },
    {
        "level": 1,
        "extreme": 11,
        "high": 10,
        "moderate": 7,
        "low": 4,
        "terrible": 2
    },
    {
        "level": 2,
        "extreme": 12,
        "high": 11,
        "moderate": 8,
        "low": 5,
        "terrible": 3
    },
    {
        "level": 3,
        "extreme": 14,
        "high": 12,
        "moderate": 9,
        "low": 6,
        "terrible": 4
    },
    {
        "level": 4,
        "extreme": 15,
        "high": 14,
        "moderate": 11,
        "low": 8,
        "terrible": 6
    },
    {
        "level": 5,
        "extreme": 17,
        "high": 15,
        "moderate": 12,
        "low": 9,
        "terrible": 7
    },
    {
        "level": 6,
        "extreme": 18,
        "high": 17,
        "moderate": 14,
        "low": 11,
        "terrible": 8
    },
    {
        "level": 7,
        "extreme": 20,
        "high": 18,
        "moderate": 15,
        "low": 12,
        "terrible": 10
    },
    {
        "level": 8,
        "extreme": 21,
        "high": 19,
        "moderate": 16,
        "low": 13,
        "terrible": 11
    },
    {
        "level": 9,
        "extreme": 23,
        "high": 21,
        "moderate": 18,
        "low": 15,
        "terrible": 12
    },
    {
        "level": 10,
        "extreme": 24,
        "high": 22,
        "moderate": 19,
        "low": 16,
        "terrible": 14
    },
    {
        "level": 11,
        "extreme": 26,
        "high": 24,
        "moderate": 21,
        "low": 18,
        "terrible": 15
    },
    {
        "level": 12,
        "extreme": 27,
        "high": 25,
        "moderate": 22,
        "low": 19,
        "terrible": 16
    },
    {
        "level": 13,
        "extreme": 29,
        "high": 26,
        "moderate": 23,
        "low": 20,
        "terrible": 18
    },
    {
        "level": 14,
        "extreme": 30,
        "high": 28,
        "moderate": 25,
        "low": 22,
        "terrible": 19
    },
    {
        "level": 15,
        "extreme": 32,
        "high": 29,
        "moderate": 26,
        "low": 23,
        "terrible": 20
    },
    {
        "level": 16,
        "extreme": 33,
        "high": 30,
        "moderate": 28,
        "low": 25,
        "terrible": 22
    },
    {
        "level": 17,
        "extreme": 35,
        "high": 32,
        "moderate": 29,
        "low": 26,
        "terrible": 23
    },
    {
        "level": 18,
        "extreme": 36,
        "high": 33,
        "moderate": 30,
        "low": 27,
        "terrible": 24
    },
    {
        "level": 19,
        "extreme": 38,
        "high": 35,
        "moderate": 32,
        "low": 29,
        "terrible": 26
    },
    {
        "level": 20,
        "extreme": 39,
        "high": 36,
        "moderate": 33,
        "low": 30,
        "terrible": 27
    },
    {
        "level": 21,
        "extreme": 41,
        "high": 38,
        "moderate": 35,
        "low": 32,
        "terrible": 28
    },
    {
        "level": 22,
        "extreme": 43,
        "high": 39,
        "moderate": 36,
        "low": 33,
        "terrible": 30
    },
    {
        "level": 23,
        "extreme": 44,
        "high": 40,
        "moderate": 37,
        "low": 34,
        "terrible": 31
    },
    {
        "level": 24,
        "extreme": 46,
        "high": 42,
        "moderate": 38,
        "low": 36,
        "terrible": 32
    }
    ],
    ac: [{
        "level": -1,
        "extreme": 18,
        "high": 15,
        "moderate": 14,
        "low": 12
    },
    {
        "level": 0,
        "extreme": 19,
        "high": 16,
        "moderate": 15,
        "low": 13
    },
    {
        "level": 1,
        "extreme": 19,
        "high": 16,
        "moderate": 15,
        "low": 13
    },
    {
        "level": 2,
        "extreme": 21,
        "high": 18,
        "moderate": 17,
        "low": 15
    },
    {
        "level": 3,
        "extreme": 22,
        "high": 19,
        "moderate": 18,
        "low": 16
    },
    {
        "level": 4,
        "extreme": 24,
        "high": 21,
        "moderate": 20,
        "low": 18
    },
    {
        "level": 5,
        "extreme": 25,
        "high": 22,
        "moderate": 21,
        "low": 19
    },
    {
        "level": 6,
        "extreme": 27,
        "high": 24,
        "moderate": 23,
        "low": 21
    },
    {
        "level": 7,
        "extreme": 28,
        "high": 25,
        "moderate": 24,
        "low": 22
    },
    {
        "level": 8,
        "extreme": 30,
        "high": 27,
        "moderate": 26,
        "low": 24
    },
    {
        "level": 9,
        "extreme": 31,
        "high": 28,
        "moderate": 27,
        "low": 25
    },
    {
        "level": 10,
        "extreme": 33,
        "high": 30,
        "moderate": 29,
        "low": 27
    },
    {
        "level": 11,
        "extreme": 34,
        "high": 31,
        "moderate": 30,
        "low": 28
    },
    {
        "level": 12,
        "extreme": 36,
        "high": 33,
        "moderate": 32,
        "low": 30
    },
    {
        "level": 13,
        "extreme": 37,
        "high": 34,
        "moderate": 33,
        "low": 31
    },
    {
        "level": 14,
        "extreme": 39,
        "high": 36,
        "moderate": 35,
        "low": 33
    },
    {
        "level": 15,
        "extreme": 40,
        "high": 37,
        "moderate": 36,
        "low": 34
    },
    {
        "level": 16,
        "extreme": 42,
        "high": 39,
        "moderate": 38,
        "low": 36
    },
    {
        "level": 17,
        "extreme": 43,
        "high": 40,
        "moderate": 39,
        "low": 37
    },
    {
        "level": 18,
        "extreme": 45,
        "high": 42,
        "moderate": 41,
        "low": 39
    },
    {
        "level": 19,
        "extreme": 46,
        "high": 43,
        "moderate": 42,
        "low": 40
    },
    {
        "level": 20,
        "extreme": 48,
        "high": 45,
        "moderate": 44,
        "low": 42
    },
    {
        "level": 21,
        "extreme": 49,
        "high": 46,
        "moderate": 45,
        "low": 43
    },
    {
        "level": 22,
        "extreme": 51,
        "high": 48,
        "moderate": 47,
        "low": 45
    },
    {
        "level": 23,
        "extreme": 52,
        "high": 49,
        "moderate": 48,
        "low": 46
    },
    {
        "level": 24,
        "extreme": 54,
        "high": 51,
        "moderate": 50,
        "low": 48
    }
    ],
    perception: [{
        "level": -1,
        "extreme": 9,
        "high": 8,
        "moderate": 5,
        "low": 2,
        "terrible": 0
    },
    {
        "level": 0,
        "extreme": 10,
        "high": 9,
        "moderate": 6,
        "low": 3,
        "terrible": 1
    },
    {
        "level": 1,
        "extreme": 11,
        "high": 10,
        "moderate": 7,
        "low": 4,
        "terrible": 2
    },
    {
        "level": 2,
        "extreme": 12,
        "high": 11,
        "moderate": 8,
        "low": 5,
        "terrible": 3
    },
    {
        "level": 3,
        "extreme": 14,
        "high": 12,
        "moderate": 9,
        "low": 6,
        "terrible": 4
    },
    {
        "level": 4,
        "extreme": 15,
        "high": 14,
        "moderate": 11,
        "low": 8,
        "terrible": 6
    },
    {
        "level": 5,
        "extreme": 17,
        "high": 15,
        "moderate": 12,
        "low": 9,
        "terrible": 7
    },
    {
        "level": 6,
        "extreme": 18,
        "high": 17,
        "moderate": 14,
        "low": 11,
        "terrible": 8
    },
    {
        "level": 7,
        "extreme": 20,
        "high": 18,
        "moderate": 15,
        "low": 12,
        "terrible": 10
    },
    {
        "level": 8,
        "extreme": 21,
        "high": 19,
        "moderate": 16,
        "low": 13,
        "terrible": 11
    },
    {
        "level": 9,
        "extreme": 23,
        "high": 21,
        "moderate": 18,
        "low": 15,
        "terrible": 12
    },
    {
        "level": 10,
        "extreme": 24,
        "high": 22,
        "moderate": 19,
        "low": 16,
        "terrible": 14
    },
    {
        "level": 11,
        "extreme": 26,
        "high": 24,
        "moderate": 21,
        "low": 18,
        "terrible": 15
    },
    {
        "level": 12,
        "extreme": 27,
        "high": 25,
        "moderate": 22,
        "low": 19,
        "terrible": 16
    },
    {
        "level": 13,
        "extreme": 29,
        "high": 26,
        "moderate": 23,
        "low": 20,
        "terrible": 18
    },
    {
        "level": 14,
        "extreme": 30,
        "high": 28,
        "moderate": 25,
        "low": 22,
        "terrible": 19
    },
    {
        "level": 15,
        "extreme": 32,
        "high": 29,
        "moderate": 26,
        "low": 23,
        "terrible": 20
    },
    {
        "level": 16,
        "extreme": 33,
        "high": 30,
        "moderate": 28,
        "low": 25,
        "terrible": 22
    },
    {
        "level": 17,
        "extreme": 35,
        "high": 32,
        "moderate": 29,
        "low": 26,
        "terrible": 23
    },
    {
        "level": 18,
        "extreme": 36,
        "high": 33,
        "moderate": 30,
        "low": 27,
        "terrible": 24
    },
    {
        "level": 19,
        "extreme": 38,
        "high": 35,
        "moderate": 32,
        "low": 29,
        "terrible": 26
    },
    {
        "level": 20,
        "extreme": 39,
        "high": 36,
        "moderate": 33,
        "low": 30,
        "terrible": 27
    },
    {
        "level": 21,
        "extreme": 41,
        "high": 38,
        "moderate": 35,
        "low": 32,
        "terrible": 28
    },
    {
        "level": 22,
        "extreme": 43,
        "high": 39,
        "moderate": 36,
        "low": 33,
        "terrible": 30
    },
    {
        "level": 23,
        "extreme": 44,
        "high": 40,
        "moderate": 37,
        "low": 34,
        "terrible": 31
    },
    {
        "level": 24,
        "extreme": 46,
        "high": 42,
        "moderate": 38,
        "low": 36,
        "terrible": 32
    }
    ],
    skill: [{
        "level": -1,
        "extreme": 8,
        "high": 5,
        "moderate": 4,
        "low": 2,
        "terrible": 1
    },
    {
        "level": 0,
        "extreme": 9,
        "high": 6,
        "moderate": 5,
        "low": 3,
        "terrible": 2
    },
    {
        "level": 1,
        "extreme": 10,
        "high": 7,
        "moderate": 6,
        "low": 4,
        "terrible": 3
    },
    {
        "level": 2,
        "extreme": 11,
        "high": 8,
        "moderate": 7,
        "low": 5,
        "terrible": 4
    },
    {
        "level": 3,
        "extreme": 13,
        "high": 10,
        "moderate": 9,
        "low": 7,
        "terrible": 5
    },
    {
        "level": 4,
        "extreme": 15,
        "high": 12,
        "moderate": 10,
        "low": 8,
        "terrible": 7
    },
    {
        "level": 5,
        "extreme": 16,
        "high": 13,
        "moderate": 12,
        "low": 10,
        "terrible": 8
    },
    {
        "level": 6,
        "extreme": 18,
        "high": 15,
        "moderate": 13,
        "low": 11,
        "terrible": 9
    },
    {
        "level": 7,
        "extreme": 20,
        "high": 17,
        "moderate": 15,
        "low": 13,
        "terrible": 11
    },
    {
        "level": 8,
        "extreme": 21,
        "high": 18,
        "moderate": 16,
        "low": 14,
        "terrible": 12
    },
    {
        "level": 9,
        "extreme": 23,
        "high": 20,
        "moderate": 18,
        "low": 16,
        "terrible": 13
    },
    {
        "level": 10,
        "extreme": 25,
        "high": 22,
        "moderate": 19,
        "low": 17,
        "terrible": 15
    },
    {
        "level": 11,
        "extreme": 26,
        "high": 23,
        "moderate": 21,
        "low": 19,
        "terrible": 16
    },
    {
        "level": 12,
        "extreme": 28,
        "high": 25,
        "moderate": 22,
        "low": 20,
        "terrible": 17
    },
    {
        "level": 13,
        "extreme": 30,
        "high": 27,
        "moderate": 24,
        "low": 22,
        "terrible": 19
    },
    {
        "level": 14,
        "extreme": 31,
        "high": 28,
        "moderate": 25,
        "low": 23,
        "terrible": 20
    },
    {
        "level": 15,
        "extreme": 33,
        "high": 30,
        "moderate": 27,
        "low": 25,
        "terrible": 21
    },
    {
        "level": 16,
        "extreme": 35,
        "high": 32,
        "moderate": 28,
        "low": 26,
        "terrible": 23
    },
    {
        "level": 17,
        "extreme": 36,
        "high": 33,
        "moderate": 30,
        "low": 28,
        "terrible": 24
    },
    {
        "level": 18,
        "extreme": 38,
        "high": 35,
        "moderate": 31,
        "low": 29,
        "terrible": 25
    },
    {
        "level": 19,
        "extreme": 40,
        "high": 37,
        "moderate": 33,
        "low": 31,
        "terrible": 27
    },
    {
        "level": 20,
        "extreme": 41,
        "high": 38,
        "moderate": 34,
        "low": 32,
        "terrible": 28
    },
    {
        "level": 21,
        "extreme": 43,
        "high": 40,
        "moderate": 36,
        "low": "34-29"
    },
    {
        "level": 22,
        "extreme": 45,
        "high": 42,
        "moderate": 37,
        "low": 35,
        "terrible": 31
    },
    {
        "level": 23,
        "extreme": 46,
        "high": 43,
        "moderate": 38,
        "low": 36,
        "terrible": 32
    },
    {
        "level": 24,
        "extreme": 48,
        "high": 45,
        "moderate": 40,
        "low": 38,
        "terrible": 33
    }
    ],
    attack: [{
        "level": -1,
        "extreme": 10,
        "high": 8,
        "moderate": 6,
        "low": 4
    },
    {
        "level": 0,
        "extreme": 10,
        "high": 8,
        "moderate": 6,
        "low": 4
    },
    {
        "level": 1,
        "extreme": 11,
        "high": 9,
        "moderate": 7,
        "low": 5
    },
    {
        "level": 2,
        "extreme": 13,
        "high": 11,
        "moderate": 9,
        "low": 7
    },
    {
        "level": 3,
        "extreme": 14,
        "high": 12,
        "moderate": 10,
        "low": 8
    },
    {
        "level": 4,
        "extreme": 16,
        "high": 14,
        "moderate": 12,
        "low": 9
    },
    {
        "level": 5,
        "extreme": 17,
        "high": 15,
        "moderate": 13,
        "low": 11
    },
    {
        "level": 6,
        "extreme": 19,
        "high": 17,
        "moderate": 15,
        "low": 12
    },
    {
        "level": 7,
        "extreme": 20,
        "high": 18,
        "moderate": 16,
        "low": 13
    },
    {
        "level": 8,
        "extreme": 22,
        "high": 20,
        "moderate": 18,
        "low": 15
    },
    {
        "level": 9,
        "extreme": 23,
        "high": 21,
        "moderate": 19,
        "low": 16
    },
    {
        "level": 10,
        "extreme": 25,
        "high": 23,
        "moderate": 21,
        "low": 17
    },
    {
        "level": 11,
        "extreme": 27,
        "high": 24,
        "moderate": 22,
        "low": 19
    },
    {
        "level": 12,
        "extreme": 28,
        "high": 26,
        "moderate": 24,
        "low": 20
    },
    {
        "level": 13,
        "extreme": 29,
        "high": 27,
        "moderate": 25,
        "low": 21
    },
    {
        "level": 14,
        "extreme": 31,
        "high": 29,
        "moderate": 27,
        "low": 23
    },
    {
        "level": 15,
        "extreme": 32,
        "high": 30,
        "moderate": 28,
        "low": 24
    },
    {
        "level": 16,
        "extreme": 34,
        "high": 32,
        "moderate": 30,
        "low": 25
    },
    {
        "level": 17,
        "extreme": 35,
        "high": 33,
        "moderate": 31,
        "low": 27
    },
    {
        "level": 18,
        "extreme": 37,
        "high": 35,
        "moderate": 33,
        "low": 28
    },
    {
        "level": 19,
        "extreme": 38,
        "high": 36,
        "moderate": 34,
        "low": 29
    },
    {
        "level": 20,
        "extreme": 40,
        "high": 38,
        "moderate": 36,
        "low": 31
    },
    {
        "level": 21,
        "extreme": 41,
        "high": 39,
        "moderate": 37,
        "low": 32
    },
    {
        "level": 22,
        "extreme": 43,
        "high": 41,
        "moderate": 39,
        "low": 33
    },
    {
        "level": 23,
        "extreme": 44,
        "high": 42,
        "moderate": 40,
        "low": 35
    },
    {
        "level": 24,
        "extreme": 46,
        "high": 44,
        "moderate": 42,
        "low": 36
    }
    ],
    damage: [{
        "level": -1,
        "extreme": "1d6+1 (4)",
        "high": "1d4+1 (3)",
        "moderate": "1d4 (3)",
        "low": "1d4 (2)"
    },
    {
        "level": 0,
        "extreme": "1d6+3 (6)",
        "high": "1d6+2 (5)",
        "moderate": "1d4+2 (4)",
        "low": "1d4+1 (3)"
    },
    {
        "level": 1,
        "extreme": "1d8+4 (8)",
        "high": "1d6+3 (6)",
        "moderate": "1d6+2 (5)",
        "low": "1d4+2 (4)"
    },
    {
        "level": 2,
        "extreme": "1d12+4 (11)",
        "high": "1d10+4 (9)",
        "moderate": "1d8+4 (8)",
        "low": "1d6+3 (6)"
    },
    {
        "level": 3,
        "extreme": "1d12+8 (15)",
        "high": "1d10+6 (12)",
        "moderate": "1d8+6 (10)",
        "low": "1d6+5 (8)"
    },
    {
        "level": 4,
        "extreme": "2d10+7 (18)",
        "high": "2d8+5 (14)",
        "moderate": "2d6+5 (12)",
        "low": "2d4+4 (9)"
    },
    {
        "level": 5,
        "extreme": "2d12+7 (20)",
        "high": "2d8+7 (16)",
        "moderate": "2d6+6 (13)",
        "low": "2d4+6 (11)"
    },
    {
        "level": 6,
        "extreme": "2d12+10 (23)",
        "high": "2d8+9 (18)",
        "moderate": "2d6+8 (15)",
        "low": "2d4+7 (12)"
    },
    {
        "level": 7,
        "extreme": "2d12+12 (25)",
        "high": "2d10+9 (20)",
        "moderate": "2d8+8 (17)",
        "low": "2d6+6 (13)"
    },
    {
        "level": 8,
        "extreme": "2d12+15 (28)",
        "high": "2d10+11 (22)",
        "moderate": "2d8+9 (18)",
        "low": "2d6+8 (15)"
    },
    {
        "level": 9,
        "extreme": "2d12+17 (30)",
        "high": "2d10+13 (24)",
        "moderate": "2d8+11 (20)",
        "low": "2d6+9 (16)"
    },
    {
        "level": 10,
        "extreme": "2d12+20 (33)",
        "high": "2d12+13 (26)",
        "moderate": "2d10+11 (22)",
        "low": "2d6+10 (17)"
    },
    {
        "level": 11,
        "extreme": "2d12+22 (35)",
        "high": "2d12+15 (28)",
        "moderate": "2d10+12 (23)",
        "low": "2d8+10 (19)"
    },
    {
        "level": 12,
        "extreme": "3d12+19 (38)",
        "high": "3d10+14 (30)",
        "moderate": "3d8+12 (25)",
        "low": "3d6+10 (20)"
    },
    {
        "level": 13,
        "extreme": "3d12+21 (40)",
        "high": "3d10+16 (32)",
        "moderate": "3d8+14 (27)",
        "low": "3d6+11 (21)"
    },
    {
        "level": 14,
        "extreme": "3d12+24 (43)",
        "high": "3d10+18 (34)",
        "moderate": "3d8+15 (28)",
        "low": "3d6+13 (23)"
    },
    {
        "level": 15,
        "extreme": "3d12+26 (45)",
        "high": "3d12+17 (36)",
        "moderate": "3d10+14 (30)",
        "low": "3d6+14 (24)"
    },
    {
        "level": 16,
        "extreme": "3d12+29 (48)",
        "high": "3d12+18 (37)",
        "moderate": "3d10+15 (31)",
        "low": "3d6+15 (25)"
    },
    {
        "level": 17,
        "extreme": "3d12+31 (50)",
        "high": "3d12+19 (38)",
        "moderate": "3d10+16 (32)",
        "low": "3d6+16 (26)"
    },
    {
        "level": 18,
        "extreme": "3d12+34 (53)",
        "high": "3d12+20 (40)",
        "moderate": "3d10+17 (33)",
        "low": "3d6+17 (27)"
    },
    {
        "level": 19,
        "extreme": "4d12+29 (55)",
        "high": "4d10+20 (42)",
        "moderate": "4d8+17 (35)",
        "low": "4d6+14 (28)"
    },
    {
        "level": 20,
        "extreme": "4d12+32 (58)",
        "high": "4d10+22 (44)",
        "moderate": "4d8+19 (37)",
        "low": "4d6+15 (29)"
    },
    {
        "level": 21,
        "extreme": "4d12+34 (60)",
        "high": "4d10+24 (46)",
        "moderate": "4d8+20 (38)",
        "low": "4d6+17 (31)"
    },
    {
        "level": 22,
        "extreme": "4d12+37 (63)",
        "high": "4d10+26 (48)",
        "moderate": "4d8+22 (40)",
        "low": "4d6+18 (32)"
    },
    {
        "level": 23,
        "extreme": "4d12+39 (65)",
        "high": "4d12+24 (50)",
        "moderate": "4d10+20 (42)",
        "low": "4d6+19 (33)"
    },
    {
        "level": 24,
        "extreme": "4d12+42 (68)",
        "high": "4d12+26 (52)",
        "moderate": "4d10+22 (44)",
        "low": "4d6+21 (35)"
    }
    ],
    dc: [{
        "level": -1,
        "extreme": 19,
        "high": 16,
        "moderate": 13
    },
    {
        "level": 0,
        "extreme": 19,
        "high": 16,
        "moderate": 13
    },
    {
        "level": 1,
        "extreme": 20,
        "high": 17,
        "moderate": 14
    },
    {
        "level": 2,
        "extreme": 22,
        "high": 18,
        "moderate": 15
    },
    {
        "level": 3,
        "extreme": 23,
        "high": 20,
        "moderate": 17
    },
    {
        "level": 4,
        "extreme": 25,
        "high": 21,
        "moderate": 18
    },
    {
        "level": 5,
        "extreme": 26,
        "high": 22,
        "moderate": 19
    },
    {
        "level": 6,
        "extreme": 27,
        "high": 24,
        "moderate": 21
    },
    {
        "level": 7,
        "extreme": 29,
        "high": 25,
        "moderate": 22
    },
    {
        "level": 8,
        "extreme": 30,
        "high": 26,
        "moderate": 23
    },
    {
        "level": 9,
        "extreme": 32,
        "high": 28,
        "moderate": 25
    },
    {
        "level": 10,
        "extreme": 33,
        "high": 29,
        "moderate": 26
    },
    {
        "level": 11,
        "extreme": 34,
        "high": 30,
        "moderate": 27
    },
    {
        "level": 12,
        "extreme": 36,
        "high": 32,
        "moderate": 29
    },
    {
        "level": 13,
        "extreme": 37,
        "high": 33,
        "moderate": 30
    },
    {
        "level": 14,
        "extreme": 39,
        "high": 34,
        "moderate": 31
    },
    {
        "level": 15,
        "extreme": 40,
        "high": 36,
        "moderate": 33
    },
    {
        "level": 16,
        "extreme": 41,
        "high": 37,
        "moderate": 34
    },
    {
        "level": 17,
        "extreme": 43,
        "high": 38,
        "moderate": 35
    },
    {
        "level": 18,
        "extreme": 44,
        "high": 40,
        "moderate": 37
    },
    {
        "level": 19,
        "extreme": 46,
        "high": 41,
        "moderate": 38
    },
    {
        "level": 20,
        "extreme": 47,
        "high": 42,
        "moderate": 39
    },
    {
        "level": 21,
        "extreme": 48,
        "high": 44,
        "moderate": 41
    },
    {
        "level": 22,
        "extreme": 50,
        "high": 45,
        "moderate": 42
    },
    {
        "level": 23,
        "extreme": 51,
        "high": 46,
        "moderate": 43
    },
    {
        "level": 24,
        "extreme": 52,
        "high": 48,
        "moderate": 45
    }
    ],
    spell: [{
        "level": -1,
        "extreme": 11,
        "high": 8,
        "moderate": 5
    },
    {
        "level": 0,
        "extreme": 11,
        "high": 8,
        "moderate": 5
    },
    {
        "level": 1,
        "extreme": 12,
        "high": 9,
        "moderate": 6
    },
    {
        "level": 2,
        "extreme": 14,
        "high": 10,
        "moderate": 7
    },
    {
        "level": 3,
        "extreme": 15,
        "high": 12,
        "moderate": 9
    },
    {
        "level": 4,
        "extreme": 17,
        "high": 13,
        "moderate": 10
    },
    {
        "level": 5,
        "extreme": 18,
        "high": 14,
        "moderate": 11
    },
    {
        "level": 6,
        "extreme": 19,
        "high": 16,
        "moderate": 13
    },
    {
        "level": 7,
        "extreme": 21,
        "high": 17,
        "moderate": 14
    },
    {
        "level": 8,
        "extreme": 22,
        "high": 18,
        "moderate": 15
    },
    {
        "level": 9,
        "extreme": 24,
        "high": 20,
        "moderate": 17
    },
    {
        "level": 10,
        "extreme": 25,
        "high": 21,
        "moderate": 18
    },
    {
        "level": 11,
        "extreme": 26,
        "high": 22,
        "moderate": 19
    },
    {
        "level": 12,
        "extreme": 28,
        "high": 24,
        "moderate": 21
    },
    {
        "level": 13,
        "extreme": 29,
        "high": 25,
        "moderate": 22
    },
    {
        "level": 14,
        "extreme": 31,
        "high": 26,
        "moderate": 23
    },
    {
        "level": 15,
        "extreme": 32,
        "high": 28,
        "moderate": 25
    },
    {
        "level": 16,
        "extreme": 33,
        "high": 29,
        "moderate": 26
    },
    {
        "level": 17,
        "extreme": 35,
        "high": 30,
        "moderate": 27
    },
    {
        "level": 18,
        "extreme": 36,
        "high": 32,
        "moderate": 29
    },
    {
        "level": 19,
        "extreme": 38,
        "high": 33,
        "moderate": 30
    },
    {
        "level": 20,
        "extreme": 39,
        "high": 34,
        "moderate": 31
    },
    {
        "level": 21,
        "extreme": 40,
        "high": 36,
        "moderate": 33
    },
    {
        "level": 22,
        "extreme": 42,
        "high": 37,
        "moderate": 34
    },
    {
        "level": 23,
        "extreme": 43,
        "high": 38,
        "moderate": 35
    },
    {
        "level": 24,
        "extreme": 44,
        "high": 40,
        "moderate": 37
    }
    ],
    item: [{
        "level": -1,
        "item": 0,
        "note": ""
    },
    {
        "level": 0,
        "item": 0,
        "note": ""
    },
    {
        "level": 1,
        "item": 0,
        "note": ""
    },
    {
        "level": 2,
        "item": 0,
        "note": ""
    },
    {
        "level": 3,
        "item": 0,
        "note": ""
    },
    {
        "level": 4,
        "item": 1,
        "note": ""
    },
    {
        "level": 5,
        "item": 1,
        "note": ""
    },
    {
        "level": 6,
        "item": 2,
        "note": "(+1 weapon)"
    },
    {
        "level": 7,
        "item": 3,
        "note": "(+1 weapon)"
    },
    {
        "level": 8,
        "item": 4,
        "note": "(+1 striking weapon)"
    },
    {
        "level": 9,
        "item": 5,
        "note": "(+1 armor)"
    },
    {
        "level": 10,
        "item": 6,
        "note": "(+1 armor)"
    },
    {
        "level": 11,
        "item": 7,
        "note": "(+1 armor)"
    },
    {
        "level": 12,
        "item": 8,
        "note": "(+1 resilient armor)"
    },
    {
        "level": 13,
        "item": 9,
        "note": "(+1 resilient armor)"
    },
    {
        "level": 14,
        "item": 10,
        "note": "(+2 striking weapon)"
    },
    {
        "level": 15,
        "item": 11,
        "note": "(+2 resilient armor)"
    },
    {
        "level": 16,
        "item": 12,
        "note": "(+2 greater striking weapon)"
    },
    {
        "level": 17,
        "item": 13,
        "note": "(+2 greater striking weapon)"
    },
    {
        "level": 18,
        "item": 14,
        "note": "(+2 greater resilient armor)"
    },
    {
        "level": 19,
        "item": 15,
        "note": "(+2 greater resilient armor)"
    },
    {
        "level": 20,
        "item": 16,
        "note": "(+3 greater striking weapon)"
    },
    {
        "level": 21,
        "item": 17,
        "note": "(+3 greater striking weapon)"
    },
    {
        "level": 22,
        "item": 18,
        "note": "(+3 greater resilient armor)"
    },
    {
        "level": 23,
        "item": 19,
        "note": "(+3 major striking weapon)"
    },
    {
        "level": 24,
        "item": 20,
        "note": "(+3 major resilient armor)"
    }
    ],
    resistance: [{
        "level": -1,
        "maximum": 1,
        "minimum": 1
    },
    {
        "level": 0,
        "maximum": 3,
        "minimum": 1
    },
    {
        "level": 1,
        "maximum": 3,
        "minimum": 2
    },
    {
        "level": 2,
        "maximum": 5,
        "minimum": 2
    },
    {
        "level": 3,
        "maximum": 6,
        "minimum": 3
    },
    {
        "level": 4,
        "maximum": 7,
        "minimum": 4
    },
    {
        "level": 5,
        "maximum": 8,
        "minimum": 4
    },
    {
        "level": 6,
        "maximum": 9,
        "minimum": 5
    },
    {
        "level": 7,
        "maximum": 10,
        "minimum": 5
    },
    {
        "level": 8,
        "maximum": 11,
        "minimum": 6
    },
    {
        "level": 9,
        "maximum": 12,
        "minimum": 6
    },
    {
        "level": 10,
        "maximum": 13,
        "minimum": 7
    },
    {
        "level": 11,
        "maximum": 14,
        "minimum": 7
    },
    {
        "level": 12,
        "maximum": 15,
        "minimum": 8
    },
    {
        "level": 13,
        "maximum": 16,
        "minimum": 8
    },
    {
        "level": 14,
        "maximum": 17,
        "minimum": 9
    },
    {
        "level": 15,
        "maximum": 18,
        "minimum": 9
    },
    {
        "level": 16,
        "maximum": 19,
        "minimum": 9
    },
    {
        "level": 17,
        "maximum": 19,
        "minimum": 10
    },
    {
        "level": 18,
        "maximum": 20,
        "minimum": 10
    },
    {
        "level": 19,
        "maximum": 21,
        "minimum": 11
    },
    {
        "level": 20,
        "maximum": 22,
        "minimum": 11
    },
    {
        "level": 21,
        "maximum": 23,
        "minimum": 12
    },
    {
        "level": 22,
        "maximum": 24,
        "minimum": 12
    },
    {
        "level": 23,
        "maximum": 25,
        "minimum": 13
    },
    {
        "level": 24,
        "maximum": 26,
        "minimum": 13
    }
    ],
    weakness: [{
        "level": -1,
        "maximum": 1,
        "minimum": 1
    },
    {
        "level": 0,
        "maximum": 3,
        "minimum": 1
    },
    {
        "level": 1,
        "maximum": 3,
        "minimum": 2
    },
    {
        "level": 2,
        "maximum": 5,
        "minimum": 2
    },
    {
        "level": 3,
        "maximum": 6,
        "minimum": 3
    },
    {
        "level": 4,
        "maximum": 7,
        "minimum": 4
    },
    {
        "level": 5,
        "maximum": 8,
        "minimum": 4
    },
    {
        "level": 6,
        "maximum": 9,
        "minimum": 5
    },
    {
        "level": 7,
        "maximum": 10,
        "minimum": 5
    },
    {
        "level": 8,
        "maximum": 11,
        "minimum": 6
    },
    {
        "level": 9,
        "maximum": 12,
        "minimum": 6
    },
    {
        "level": 10,
        "maximum": 13,
        "minimum": 7
    },
    {
        "level": 11,
        "maximum": 14,
        "minimum": 7
    },
    {
        "level": 12,
        "maximum": 15,
        "minimum": 8
    },
    {
        "level": 13,
        "maximum": 16,
        "minimum": 8
    },
    {
        "level": 14,
        "maximum": 17,
        "minimum": 9
    },
    {
        "level": 15,
        "maximum": 18,
        "minimum": 9
    },
    {
        "level": 16,
        "maximum": 19,
        "minimum": 9
    },
    {
        "level": 17,
        "maximum": 19,
        "minimum": 10
    },
    {
        "level": 18,
        "maximum": 20,
        "minimum": 10
    },
    {
        "level": 19,
        "maximum": 21,
        "minimum": 11
    },
    {
        "level": 20,
        "maximum": 22,
        "minimum": 11
    },
    {
        "level": 21,
        "maximum": 23,
        "minimum": 12
    },
    {
        "level": 22,
        "maximum": 24,
        "minimum": 12
    },
    {
        "level": 23,
        "maximum": 25,
        "minimum": 13
    },
    {
        "level": 24,
        "maximum": 26,
        "minimum": 13
    }
    ],
    area: [{
        "level": -1,
        "unlimited": "1d4 (2)",
        "limited": "1d6 (4)"
    },
    {
        "level": 0,
        "unlimited": "1d6 (4)",
        "limited": "1d10 (6)"
    },
    {
        "level": 1,
        "unlimited": "2d4 (5)",
        "limited": "2d6 (7)"
    },
    {
        "level": 2,
        "unlimited": "2d6 (7)",
        "limited": "3d6 (11)"
    },
    {
        "level": 3,
        "unlimited": "2d8 (9)",
        "limited": "4d6 (14)"
    },
    {
        "level": 4,
        "unlimited": "3d6 (11)",
        "limited": "5d6 (18)"
    },
    {
        "level": 5,
        "unlimited": "2d10 (12)",
        "limited": "6d6 (21)"
    },
    {
        "level": 6,
        "unlimited": "4d6 (14)",
        "limited": "7d6 (25)"
    },
    {
        "level": 7,
        "unlimited": "4d6 (15)",
        "limited": "8d6 (28)"
    },
    {
        "level": 8,
        "unlimited": "5d6 (17)",
        "limited": "9d6 (32)"
    },
    {
        "level": 9,
        "unlimited": "5d6 (18)",
        "limited": "10d6 (35)"
    },
    {
        "level": 10,
        "unlimited": "6d6 (20)",
        "limited": "11d6 (39)"
    },
    {
        "level": 11,
        "unlimited": "6d6 (21)",
        "limited": "12d6 (42)"
    },
    {
        "level": 12,
        "unlimited": "5d8 (23)",
        "limited": "13d6 (46)"
    },
    {
        "level": 13,
        "unlimited": "7d6 (24)",
        "limited": "14d6 (49)"
    },
    {
        "level": 14,
        "unlimited": "4d12 (26)",
        "limited": "15d6 (53)"
    },
    {
        "level": 15,
        "unlimited": "8d6 (27)",
        "limited": "16d6 (56)"
    },
    {
        "level": 16,
        "unlimited": "8d6 (28)",
        "limited": "17d6 (60)"
    },
    {
        "level": 17,
        "unlimited": "8d6 (29)",
        "limited": "18d6 (63)"
    },
    {
        "level": 18,
        "unlimited": "9d6 (30)",
        "limited": "19d6 (67)"
    },
    {
        "level": 19,
        "unlimited": "9d6 (32)",
        "limited": "20d6 (70)"
    },
    {
        "level": 20,
        "unlimited": "6d10 (33)",
        "limited": "21d6 (74)"
    },
    {
        "level": 21,
        "unlimited": "10d6 (35)",
        "limited": "22d6 (77)"
    },
    {
        "level": 22,
        "unlimited": "8d8 (36)",
        "limited": "23d6 (81)"
    },
    {
        "level": 23,
        "unlimited": "11d6 (38)",
        "limited": "24d6 (84)"
    },
    {
        "level": 24,
        "unlimited": "11d6 (39)",
        "limited": "25d6 (88)"
    }
    ],
    trait: [],
    level: [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
    alignment: ['lg', 'ng', 'cg', 'ln', 'n', 'cn', 'le', 'ne', 'ce', '-'],
    size: ['tiny', 'small', 'medium', 'large', 'huge', 'gargantuan', '-'],
    type: ['aberration', 'animal', 'astral', 'beast', 'celestial', 'construct', 'dragon', 'elemental', 'ethereal', 'fey', 'fiend', 'fungus', 'humanoid', 'monitor', 'ooze', 'plant', 'spirit', 'undead', '-'],
    element: [  'air',  'body',  'darkness',  'death',  'earth',  'fire',  'force',  'ice',  'light',  'lightning',  'life',  'metal',  'mind',  'music',  'poison',  'spirit',  'space',  'time',  'water',  'wood'],
    adjustment: [5, 4, 3, 2, 1, 0, -1, -2, -3, -4, -5],
    action: ['none', 'one', 'two', 'three', 'free', 'reaction', '1 minute', '10 minutes'],
    special: ['general', 'offense', 'defense'],
    label: {
        ability: ["strength", "dexterity", "constitution", "intelligence", "wisdom", "charisma"],
        skill: ["acrobatics", "arcana", "athletics", "crafting", "deception", "diplomacy", "intimidation", "medicine", "nature", "occultism", "performance", "religion", "society", "stealth", "survival", "thievery", "lore", "lorealt"],
        save: ["fortitude", "reflex", "will"],
        defense: ["armor class", "fortitude", "reflex", "will"],
        prof: ["untrained", "trained", "expert", "master", "legendary"],
        resist: ["resistance", "weakness"],
        spell: ['spell attack', 'spell dc'],
        level: ['10th', '9th', '8th', '7th', '6th', '5th', '4th', '3rd', '2nd', '1st', 'Cantrips'],
    },
    column: {
        ability: ['extreme', 'high', 'moderate', 'low', 'terrible', 'abysmal'],
        attack: ['extreme', 'high', 'moderate', 'low'],
        skill: ['extreme', 'high', 'moderate', 'low', 'terrible'],
        spell: ['extreme', 'high', 'moderate'],
        dc: ['extreme', 'high', 'moderate'],
        resist: ['extreme', 'high', 'moderate', 'low'],
        perception: ['extreme', 'high', 'moderate', 'low', 'terrible'],
        ac: ['extreme', 'high', 'moderate', 'low'],
        save: ['extreme', 'high', 'moderate', 'low', 'terrible'],
        hp: ['high', 'moderate', 'low'],
    },
    benchmark: {
        defense: ['ac', 'save', 'save', 'save'],
        spell: ['spell', 'dc']
    },
    alias: {
        defense: ['ac', 'fortitude', 'reflex', 'will'],
        spell: ['spellattack', 'spelldc']
    },
    hint: {
        ability: ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma'],
        save: ['fortitude', 'reflex', 'will'],
        perception: ['perception'],
        hp: ['hp'],
        ac: ['ac'],
        skill: ["acrobatics", "arcana", "athletics", "crafting", "deception", "diplomacy", "intimidation", "medicine", "nature", "occultism", "performance", "religion", "society", "stealth", "survival", "thievery", "lore", "lorealt"],
        spell: ['spellattack'],
        dc: ['spelldc']
    },
    name: {
        'dc': 'spelldc',
        'fort': 'fortitude',
        'ref': 'reflex',
        'str': 'strength',
        'dex': 'dexterity',
        'con': 'constitution',
        'wis': 'wisdom',
        'int': 'intelligence',
        'cha': 'charisma'
    },
    roadmap: {
        'brute': {
            icon: 'fist-raised',
            comment: {
                'offense': "High attack and high damage, or low attack and extreme damage.",
                'perception': "Low perception.",
                'defense': "Moderate to low AC. High Fortitude save. Low Reflex save, or low Will save, or both. High HP.",
                'ability modifiers': "High or extreme Strength. High to moderate Constitution. Low or lower Dexterity. Low or lower mental modifiers."
            },
            benchmark: {
                perception: ['low'],
                strength: ['high', 'extreme'],
                constitution: ['moderate', 'high'],
                dexterity: ['low', 'low-1', 'low-2'],
                wisdom: ['low', 'low-1', 'low-2'],
                intelligence: ['low', 'low-1', 'low-2'],
                charisma: ['low', 'low-1', 'low-2'],
                ac: ['low', 'moderate'],
                fortitude: ['high'],
                reflex: ['low', 'moderate', 'moderate'],
                will: ['low', 'moderate', 'moderate'],
                hp: ['high']
            }
        },
        'magical striker': {
            icon: "meteor",
            comment: {
                'offense': 'High attack and high damage.',
                'spells': 'Moderate to high spell DCs. Either a scattering of innate spells, or prepared or spontaneous spells up to half the creature level (rounded up) minus 1.',
            },
            benchmark: {
                perception: ['moderate'],
                spelldc: ['moderate', 'high'],
                dexterity: ['low', 'moderate-1', 'moderate'],
                strength: ['low', 'moderate-1', 'moderate'],
                constitution: ['low', 'moderate-1', 'moderate'],
                intelligence: ['low', 'moderate-1', 'moderate'],
                wisdom: ['low', 'moderate-1', 'moderate'],
                charisma: ['low', 'moderate-1', 'moderate'],
                fortitude: ['low'],
                will: ['high'],
                reflex: ['moderate'],
                ac: ['moderate'],
                hp: ['moderate']
            }
        },
        'skirmisher': {
            icon: "flag",
            comment: {
                "ability modifiers": "High Dexterity.",
                "defense": "Low Fortitude save. High Reflex save.",
                "offense": "Higher speed than usual."
            },
            benchmark: {
                perception: ['moderate'],
                strength: ['low-1', 'low', 'moderate'],
                constitution: ['moderate'],
                intelligence: ['low-1', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['high'],
                fortitude: ['low'],
                will: ['moderate'],
                reflex: ['high'],
                ac: ['moderate'],
                hp: ['moderate']
            }
        },
        'sniper': {
            icon: "crosshairs",
            comment: {
                "perception": "High Perception.",
                "ability modifiers": "High Dexterity.",
                "defense": "Low Fortitude save. High Reflex save. Moderate to low HP.",
                "offense": "Ranged strikes have high attack and high damage, or moderate attack and extreme damage. Melee strikes are weaker."
            },
            benchmark: {
                perception: ['high'],
                dexterity: ['high'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['moderate'],
                intelligence: ['low-1', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low-1', 'low', 'low', 'moderate'],
                fortitude: ['low'],
                reflex: ['high'],
                will: ['moderate'],
                hp: ['low', 'moderate'],
                ac: ['moderate']
            }
        },
        'soldier': {
            icon: "medal",
            comment: {
                "ability modifiers": "High Strength.",
                "defense": "High to extreme AC. High Fortitude save.",
                "offense": "High attack and high damage.",
                "special abilities": "Attack of Opportunity and other tactical abilities."
            },
            benchmark: {
                perception: ['moderate'],
                hp: ['moderate'],
                strength: ['high'],
                dexterity: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['moderate'],
                intelligence: ['low-1', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low-1', 'low', 'low', 'moderate'],
                ac: ['high', 'extreme'],
                fortitude: ['high'],
                will: ['moderate'],
                reflex: ['moderate']
            }
        },
        'spellcaster (int)': {
            icon: "hat-wizard",
            comment: {
                "ability modifiers": "High or extreme Intelligence.",
                "defense": "Low Fortitude save. High Will save. Low HP.",
                "offense": "Low attack bonus and moderate or low damage.",
                "spells": "High or extreme spell DCs. Prepared or spontaneous spells up to half the creature level (rounded up)."
            },
            benchmark: {
                perception: ['moderate'],
                intelligence: ['high', 'extreme'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['low-1', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low-1', 'low', 'low', 'moderate'],
                fortitude: ['low'],
                will: ['high'],
                reflex: ['moderate'],
                hp: ['low'],
                spelldc: ['high', 'extreme'],
                ac: ['moderate']
            }
        },
        'spellcaster (wis)': {
            icon: "sun",
            comment: {
                "ability modifiers": "High or extreme Wisdom.",
                "defense": "Low Fortitude save. High Will save. Low HP.",
                "offense": "Low attack bonus and moderate or low damage.",
                "spells": "High or extreme spell DCs. Prepared or spontaneous spells up to half the creature level (rounded up)."
            },
            benchmark: {
                perception: ['moderate'],
                wisdom: ['high', 'extreme'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['low-1', 'low', 'low', 'moderate'],
                intelligence: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low-1', 'low', 'low', 'moderate'],
                fortitude: ['low'],
                will: ['high'],
                reflex: ['moderate'],
                hp: ['low'],
                spelldc: ['high', 'extreme'],
                ac: ['moderate']
            }
        },
        'spellcaster (cha)': {
            icon: "magic",
            comment: {
                "ability modifiers": "High or extreme Charisma.",
                "defense": "Low Fortitude save. High Will save. Low HP.",
                "offense": "Low attack bonus and moderate or low damage.",
                "spells": "High or extreme spell DCs. Prepared or spontaneous spells up to half the creature level (rounded up)."
            },
            benchmark: {
                perception: ['moderate'],
                charisma: ['high', 'extreme'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['low-1', 'low', 'low', 'moderate'],
                intelligence: ['low-1', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                fortitude: ['low'],
                will: ['high'],
                reflex: ['moderate'],
                hp: ['low'],
                spelldc: ['high', 'extreme'],
                ac: ['moderate']
            }
        },
        'skill paragon (str)': {
            icon: "dumbbell",
            comment: {
                "ability modifiers": "High or extreme ability modifiers matching its best skills.",
                "defense": "High Reflex save or Will save, and low Fortitude save.",
                "skills": "Many skills at moderate or high, and potentially one or two extreme skills.",
                "special abilities": "At least one special ability to use the creature's skills in combat."
            },
            benchmark: {
                perception: ['moderate'],
                hp: ['moderate'],
                strength: ['high', 'extreme'],
                dexterity: ['low', 'low', 'low', 'moderate'],
                constitution: ['low', 'low', 'low', 'moderate'],
                intelligence: ['low', 'low', 'low', 'moderate'],
                wisdom: ['low-1', 'low', 'low', 'moderate'],
                charisma: ['low', 'low', 'low', 'moderate'],
                will: ['moderate'],
                reflex: ['high'],
                fortitude: ['low'],
                athletics: ['high', 'extreme'],
                acrobatics: ['moderate'],
                intimidation: ['moderate'],
                stealth: ['moderate'],
                ac: ['moderate']
            }
        },
        'skill paragon (dex)': {
            icon: "mask",
            comment: {
                "ability modifiers": "High or extreme ability modifiers matching its best skills.",
                "defense": "High Reflex save or Will save, and low Fortitude save.",
                "skills": "Many skills at moderate or high, and potentially one or two extreme skills.",
                "special abilities": "At least one special ability to use the creature's skills in combat."
            },
            benchmark: {
                perception: ['moderate', 'high'],
                hp: ['moderate'],
                dexterity: ['high', 'extreme'],
                strength: ['low', 'low', 'low', 'moderate'],
                constitution: ['low-1', 'low', 'low', 'moderate'],
                intelligence: ['low', 'low', 'low', 'moderate'],
                wisdom: ['low', 'low', 'low', 'moderate'],
                charisma: ['low', 'low', 'low', 'moderate'],
                will: ['moderate'],
                reflex: ['high'],
                fortitude: ['low'],
                acrobatics: ['high', 'extreme'],
                stealth: ['high', 'extreme'],
                athletics: ['moderate'],
                deception: ['moderate'],
                diplomacy: ['moderate'],
                ac: ['moderate']
            }
        },
        'skill paragon (wis)': {
            icon: "seedling",
            comment: {
                "ability modifiers": "High or extreme ability modifiers matching its best skills.",
                "defense": "High Reflex save or Will save, and low Fortitude save.",
                "skills": "Many skills at moderate or high, and potentially one or two extreme skills.",
                "special abilities": "At least one special ability to use the creature's skills in combat."
            },
            benchmark: {
                perception: ['moderate', 'high'],
                hp: ['moderate'],
                wisdom: ['high', 'extreme'],
                strength: ['low', 'low', 'low', 'moderate'],
                dexterity: ['low-1', 'low', 'low', 'moderate'],
                constitution: ['low', 'low', 'low', 'moderate'],
                intelligence: ['low', 'low', 'low', 'moderate'],
                charisma: ['low', 'low', 'low', 'moderate'],
                reflex: ['moderate'],
                will: ['high'],
                fortitude: ['low'],
                medicine: ['high', 'extreme'],
                religion: ['high', 'extreme'],
                nature: ['high', 'extreme'],
                survival: ['moderate'],
                stealth: ['moderate'],
                ac: ['moderate']
            }
        },
        'skill paragon (int)': {
            icon: "glasses",
            comment: {
                "ability modifiers": "High or extreme ability modifiers matching its best skills.",
                "defense": "High Reflex save or Will save, and low Fortitude save.",
                "skills": "Many skills at moderate or high, and potentially one or two extreme skills.",
                "special abilities": "At least one special ability to use the creature's skills in combat."
            },
            benchmark: {
                perception: ['moderate', 'high'],
                hp: ['moderate'],
                intelligence: ['high', 'extreme'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['low', 'low', 'low', 'moderate'],
                constitution: ['low', 'low', 'low', 'moderate'],
                wisdom: ['low', 'low', 'low', 'moderate'],
                charisma: ['low', 'low', 'low', 'moderate'],
                will: ['high'],
                reflex: ['moderate'],
                fortitude: ['low'],
                arcana: ['high', 'extreme'],
                crafting: ['high', 'extreme'],
                occultism: ['high', 'extreme'],
                society: ['high', 'extreme'],
                deception: ['moderate'],
                diplomacy: ['moderate'],
                stealth: ['moderate'],
                ac: ['moderate']
            }
        },
        'skill paragon (cha)': {
            icon: "comment",
            comment: {
                "ability modifiers": "High or extreme ability modifiers matching its best skills.",
                "defense": "High Reflex save or Will save, and low Fortitude save.",
                "skills": "Many skills at moderate or high, and potentially one or two extreme skills.",
                "special abilities": "At least one special ability to use the creature's skills in combat."
            },
            benchmark: {
                perception: ['moderate'],
                hp: ['moderate'],
                charisma: ['high', 'extreme'],
                strength: ['low-1', 'low', 'low', 'moderate'],
                dexterity: ['low', 'low', 'low', 'moderate'],
                constitution: ['low', 'low', 'low', 'moderate'],
                intelligence: ['low', 'low', 'low', 'moderate'],
                wisdom: ['low', 'low', 'low', 'moderate'],
                will: ['high'],
                reflex: ['moderate'],
                fortitude: ['low'],
                diplomacy: ['high', 'extreme'],
                deception: ['high', 'extreme'],
                performance: ['high', 'extreme'],
                society: ['moderate'],
                intimidation: ['moderate'],
                acrobatics: ['moderate'],
                ac: ['moderate']
            }
        },
        'complete nonsense': {
            icon: "dice",
            comment: {
                "ability modifiers": "Chaos."
            },
            benchmark: {
                strength: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                dexterity: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                constitution: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                intelligence: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                wisdom: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                charisma: ['extreme', 'high', 'moderate', 'low', 'low', 'terrible'],
                acrobatics: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                arcana: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                athletics: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                crafting: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                deception: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                diplomacy: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                intimidation: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                medicine: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                nature: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                occultism: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                performance: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                religion: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                society: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                stealth: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                survival: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                thievery: ['extreme', 'high', 'moderate', 'low', 'terrible', '', '', ''],
                spellattack: ['extreme', 'high', 'moderate'],
                spelldc: ['extreme', 'high', 'moderate'],
                perception: ['extreme', 'high', 'moderate', 'low', 'terrible'],
                ac: ['extreme', 'high', 'moderate', 'low'],
                fortitude: ['extreme', 'high', 'moderate', 'low', 'terrible'],
                will: ['extreme', 'high', 'moderate', 'low', 'terrible'],
                reflex: ['extreme', 'high', 'moderate', 'low', 'terrible'],
                hp: ['high', 'moderate', 'low'],
            }
        }
    },
    verbose: {
        'spelldc': 'spell dc',
        'ac': 'armor class',
        'hp': 'hit points',
        'spellattack': 'spell attack',
        'lore': 'lore one',
        'lorealt': 'lore two'
    }
}

export const Images = {
    aaa: "data:image/png;base64,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",
    aa: "data:image/png;base64,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",
    a: "data:image/png;base64,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",
    r: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAB2CAYAAAAnWxonAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU4RUZFN0U2RjU1NzExRTlBOTQzQkUxNDJCNjlBODA3IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU4RUZFN0U3RjU1NzExRTlBOTQzQkUxNDJCNjlBODA3Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RThFRkU3RTRGNTU3MTFFOUE5NDNCRTE0MkI2OUE4MDciIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RThFRkU3RTVGNTU3MTFFOUE5NDNCRTE0MkI2OUE4MDciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6v4BtDAAAJpElEQVR42uyda2xVRRDH5/LoLaXlUcBaBKoBFAUFK1KQV0UE34oEjaIJ8RVDQwgERYhGCJEEjajxgx8kSCCKQWkoQnj4CJKgQUCBCgmUUgjlIagUKxQoBWfcuaH03rb3cc7Z3XNmkn+A0rR7zv7uzOzu7G4Igmlp9f7eCpWOas1qxaqrp1rUedRF/nfEaiHgFvLhM7XmP8OorqgbUb1QPVHd+Ws5qGxUO4YlESOITqNOoU6gKlHlqP2oCtYZ1BXUJQHIfFhaoPJQd6AGou5C3c6Q6LIa1D7UHtQO1C7+96l6EApAmoBpi8pHjWLls7exwcgzbUFtRG1ir1VnM1CmA5TGbeyHGod6AtXXRxGAwNmJWof6GlXGX78AYilBk4l6HFWCOsf5RBD0B+oT1DBUG4s8qxHQZKAeRq3iT+CVgKsatYJhSheYYhu9lN6oj+qNXETRopHeTFQXAUm9AHLP41HbBI6EdBm1FlUYRJDogbNQk1HHBYaUtZdDfjgI4LRHvYWqko53XPt5dBr2IziUGBcJOJ6owk8g0UNMQB2VjvVcP/PAJM1WcG5C/SQdqT3Z/hjUWp81INESw1xQC4jSiWboL44ERkNE61N9UAekw4zVah7IGAdSGifJtdJJxotKT+52GqJQCl6HRljFoFbEvTRava5hnWOd5a9H1o/C/KLS+ZPXUib9/zcC6R3WeV0AETzdUD+CKtBy2giM30GtUh8CVax1BHWMY3rDB69tpI0Ra8n5WSdULuoGUPVD/UHVDfWydcSSgtEKwBieXvEUIOqYoag13CmpGq1/bedR21ZQhVcn+ZPiRbkoeSoqSKPis1tRg1GjQRWl+X2G9zBqOKgKAE/qkQie53mImGwcJig2o6aDqusxcZU5ncPzANQU1Hrwb3VAFT9nmhfwFCXZyL95TmIYey3bPtlhbje5/CX8PH6CiD4cj7kJEcEzK8FGUZ5CtSyF4K9aljA/D41mlvFz+gWkiW5ARPBMTqARpainQa26+z0xDfNM7yR+bj9A9JST/UbwjIvzF3+LKgjgaKb+fFg/HlzYvgQyxol+JHjuaWZZgv7vM1BrX0EFJxZItJD5VYqDDZ06z9MbKfUpbb6rbuKXbED1aDDfInYtSHkWeySab+uS7MPTiGMfNF68NEzAidva8EDioIUQbeMBQ8Kha0WMH0azwy+CFHQna7RNaQbYt0Xp3URCGcHzZIwf8huopQvxOql7ozx+nzZBFPcCbDZcW3pKSeA88TqOG6UI8y1Kso9CHMtWRFgxXLtDMl+8jqveiEa5Jy2BaF5zXqig3jf/wt5I4HEfoq5NDFhMEk3ZdG/K++zkb1yeTOYtlpJ1ALXAbDpExY15oYf4GxaK19GaF31uAUS9YzWedjguEHiMCGmLbfVCYmYY1SF9AWavleVIN5kfzjbZPCITMyOxLgdzd3fI3KAFRsX+pi59FEj3mG80nTLJUIA+ku6xB6LvDATooORB9hjNVpu4K0RGY5YYfdLnGgjQWOkae4yK9007hHSOdItdXmi2YQCVSLfYZVQhYdIpKKUyH2SfF1puEEBVApB9NhLMWhcLh6RPrJsXoiujMg1pT5Z0iX1hbLVBXkgAstBeNgigDOkO+6y/STmQdId91tYQgE6CrIdZmweZsB1oN7WlhfSHlXbEgDZQLf1FAcg+owMxqwxoBx2OCgKQnXbWgDZslW6w1zaA/p2qmeKB7DXdu4d/BYvvug+60dzLfs0eaIp0g90A/QtSziqWpOVqhmcLyASi1TZGM0CPSBfYbR+C3uULOf7H8vynQiNAdGuBnOLioFEuQIdQTvTo9w3QCA9dMiPlGw6C0xmuHolc6JH3WaQRoJfE+zhj6TwPchau1sV4UZmXqXH4fhCk9scRr0OnUpRB9InuaR54nyKN3meIdH9q4FyHWgn6dmhmgb6L7pZK6EotXE2Fps/pGeSB93lDEzx00XE7wSA5r0MHgTd3ShidmtHG5bbQjtRq0FPzLIfNJxmuiuN8yZtczn/I+5Ro8j6vgSxZJGTkSaaBupko3pc8zWV4JmiCR47zTdDrDIPk7vTq62K7cjSFrl1gzs5X48HJSSFEVLs4N0Jbd3Zomu/pKGjEF65mJBiuGmqNS26eRn6rNI24cgWN5r3OcHDmCspXXMp73tMATyXDI3lPM+HKyYMJeroAzxRNYUvgaSZcvZ5iuGqoPx1+4QTP2xrg2S45T9NeZwTqkAsv/ksHASJ43tcAz0qI4yrLoIKTC+7e2f6sQ22l+pqlGuCZISGr8XA1E9w/mDvXAa9DP2O3x+DQ6WZDBJ7YXqcQddiDTjiSYgeEObR6fe7z96DW1QSeGOFqrYcdsSiFTqCcY4HH4FAR2kQBJxocyh/eBO/vkXg0Sa8z2CMP2XCyM0fgiYZnFIcSHQuN2QmC0x61xOM20ru5V8CJBodurlkH+ko76Y73eOpjWrOHnOpxrvMPT0ZmgNQwGxGuGmphnF6HhvknPGwXTZLSEkgH8TrR8NyvMVw11KhmPM4zqAMawOkk4ESD0w210RBwSHUQvX2HwLkeNd/jUHUcNV08TmxwaKg7B8y7pW8HAxPxNg+AWpy97GEbaAsRHW6QLuA0Hq4qDQMnIjrU4EFQa0g1Hv7eah7F9RNoGgenB5h5uawu0a7X5ZxzZQg4TYereaDO2ws6NGfYu40VaOKDh17UsQADU81zWq+ibuZ3Yt0erJAGcGjUshh1X4A+MDSCK+dEnI6I+wFUJSAl4LU2P1jIQ3Do0zULVHWgX3c7EgxHQR3AsI1Vyl+rsx0WXQDRzOxo1Kfgj6r/Q6hvQB33doLnZA7zn5F9XLUg5gg4eaC2//opd6kAKQV13bJ4dvaSTxPgZSCHDrhq5eD/UdR4gci9HIim2ruDOoCyENRRKX1QLX307mp4+F0pALlvBFQrfuFDGKoChsxmK+XnqJGg462ls6i6bwQP79eDvmPcUtEHEODirZBBbYl0AtW23IkaCWof+wAw/3R0mhSlCcILApB5UwFkPRrkU7cZ1vbTqFtA7bsSM9wii7DkpWgdibYZe73bIZY2g9wjYS1QpA4c8maDuhJSRz41M2j5UMjHUEXyqXxO1Iez13LTSxBEA1F7gpIPhQL0YUnj56Wpg0GcTw0FNT/l5N2xxzlHqwKxQECVwSM9usqILk9xYgdICci+rEDnUx0dyKdeCAJEIWEm7nyqc718agR7raYAoTJdKoQvk1coFgsqSsZpaeY5ULVOeyF6i08ZSOmHWJxG3iiTvVRRvXxqkbwasWSBImX7+SH/E2AA2tjOKuElKXsAAAAASUVORK5CYII=",
    f: "data:image/png;base64,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"
}
